import React from 'react';
import { Container, Text, Link } from 'basis';
import styled from '@emotion/styled';
import { isFeatureOn } from 'featureToggles';
import { OverviewSources, PRODUCT_CODE_DAVID_JONES_PREMIERE, PRODUCT_CODE_DAVID_JONES_PRESTIGE } from '_config';
import { byCard, getProductInfo } from 'utils';
import { useEventTracking } from 'react-event-tracker';

const TileBox = styled.div`
  padding: 0 12px 12px 24px;
  margin: 15px 0 32px 0;
  @media (max-width: ${props => props.theme.screenSize?.md}) {
    margin-top: 24px;
    margin-bottom: 56px;
  }
  border-left: 12px solid #a4a7ae;
`;

export const OfferTileContainer = styled.div`
  @media (max-width: ${props => props.theme.screenSize.sm}) {
    margin: 0 0 0 8px;
    & > div {
      margin-top: 0;
      margin-bottom: 30px;
    }
  }
`;

export const OfferTileDJ = () => {
  const { trackEvent } = useEventTracking();
  if (!isFeatureOn('cvp')) return null;

  const fees = byCard({
    [PRODUCT_CODE_DAVID_JONES_PREMIERE]: { currentAnnualFee: '99', newAnnualFee: '149' },
    [PRODUCT_CODE_DAVID_JONES_PRESTIGE]: { currentAnnualFee: '295', newAnnualFee: '345' },
  });

  return (
    <OfferTileContainer>
      <TileBox>
        <Container testId="offer-title">
          <Text textStyle="heading5" bold="bold">
            Upcoming changes to the {getProductInfo().name} credit card.
          </Text>
        </Container>
        <Container margin="4 0" testId="offer-description">
          <Text bold="semiBold">Effective 25 August 2026</Text>
          <Text>
            The annual credit card fee will change from ${fees.currentAnnualFee} to ${fees.newAnnualFee}. Waived for
            your first year.
          </Text>
          <Text>
            The interest free period on general purchases will change from 'up to 55 days' to 'up to 44 days'.
          </Text>
        </Container>
        <Container testId="offer-tnc">
          <Text textStyle="legal">
            There are other changes taking effect on 25 August 2026, please{' '}
            <Link
              newTab
              href={OverviewSources.AU.disclaimerZenDeskLink.url}
              onClick={() => {
                trackEvent({
                  event: {
                    category: 'text-link',
                    action: 'external-link',
                    location: 'DJ Offer Tile',
                    label: 'Learn more',
                  },
                });
              }}
            >
              click here
            </Link>{' '}
            to learn more.
          </Text>
        </Container>
      </TileBox>
    </OfferTileContainer>
  );
};
